import { render, staticRenderFns } from "./record.vue?vue&type=template&id=b4c137b4&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"
import style0 from "./record.vue?vue&type=style&index=0&id=b4c137b4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c137b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4c137b4')) {
      api.createRecord('b4c137b4', component.options)
    } else {
      api.reload('b4c137b4', component.options)
    }
    module.hot.accept("./record.vue?vue&type=template&id=b4c137b4&scoped=true", function () {
      api.rerender('b4c137b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/free-redeem/record.vue"
export default component.exports